import { usePermissions } from "../contexts/PermissionsContext";

export const usePermissionChecker = (requiredPermission: string) => {
  const { permissions, loading } = usePermissions();

  if (loading) {
    return { hasPermission: false, loading };
  }

  return { hasPermission: permissions.includes(requiredPermission), loading };
};
